module.exports = __webpack_public_path__ + "assets/img/6fd32f0a08c2193369b3219bbbb92ceb.png";